export function ClearPlayers() {
	console.log(window.pljssglobal, "clear");
	if (window.pljssglobal.length > 1) {
		window.pljssglobal[0].api("stop");
		window.pljssglobal = window.pljssglobal.slice(1, 2);
	}
}
export function KillAllPlayers() {
	console.log(window.pljssglobal, "kill");
	if (window.pljssglobal.length > 0) {
		window.pljssglobal.forEach((api) => {
			api.api("stop");
		});
	}
	window.pljssglobal = [];
}
